import ErrorDetail from "./ErrorDetail";

export default {
  ErrorDetail
};



// WEBPACK FOOTER //
// ./src/Core/Components/Modals/index.js